/* ============================================================
   GOLDEN TECH · motor del tema  ·  GT 1.0
   Tres piezas, todas DECORATIVAS: si el JS no corre, o el visitante
   pidio menos movimiento, la tienda se lee y se compra igual.
     1) cielo    · viaje a las estrellas con chispas rojas (de G4.19)
     2) entrada  · lo que aparece al entrar en pantalla
     3) iman     · el boton sigue al cursor unos pixeles
   ============================================================ */
(function () {
  "use strict";

  var QUIETO = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function cielo(lienzo) {
    if (!lienzo || !lienzo.getContext) return;
    if (lienzo.dataset.gtListo === "1") return;
    lienzo.dataset.gtListo = "1";
    var ctx = lienzo.getContext("2d");
    if (!ctx) return;

    var VELOCIDAD = parseFloat(lienzo.dataset.velocidad) || 1.5;
    var CUANTAS   = parseInt(lienzo.dataset.estrellas, 10) || 320;
    var PCT_ROJAS = parseInt(lienzo.dataset.chispas, 10);
    if (isNaN(PCT_ROJAS)) PCT_ROJAS = 22;
    var FONDO     = lienzo.dataset.fondoRgb || "4,4,10";
    var ROJO      = lienzo.dataset.rojoRgb  || "255,59,59";

    var an = 0, al = 0, dpr = 1, cx = 0, cy = 0, estrellas = [], corriendo = false, lazo = 0;

    function medir() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      an = lienzo.clientWidth; al = lienzo.clientHeight;
      if (an === 0 || al === 0) return false;
      lienzo.width  = Math.round(an * dpr);
      lienzo.height = Math.round(al * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = an / 2; cy = al / 2;
      return true;
    }

    function nueva() {
      return {
        x: (Math.random() - 0.5) * an,
        y: (Math.random() - 0.5) * al,
        z: Math.random() * an,
        pz: 0,
        roja: Math.random() * 100 < PCT_ROJAS
      };
    }

    function poblar() {
      estrellas = [];
      for (var i = 0; i < CUANTAS; i++) { var e = nueva(); e.pz = e.z; estrellas.push(e); }
    }

    function pintar(avanza) {
      ctx.fillStyle = "rgba(" + FONDO + ",0.34)";
      ctx.fillRect(0, 0, an, al);

      for (var i = 0; i < estrellas.length; i++) {
        var e = estrellas[i];
        if (avanza) {
          e.pz = e.z;
          e.z -= VELOCIDAD * 4;
          if (e.z < 1) { var n = nueva(); n.z = an; n.pz = an; estrellas[i] = n; continue; }
        }
        var k = 128 / e.z;
        var x = cx + e.x * k;
        var y = cy + e.y * k;
        if (x < -40 || x > an + 40 || y < -40 || y > al + 40) continue;

        var kp = 128 / (e.pz || e.z);
        var px = cx + e.x * kp;
        var py = cy + e.y * kp;

        var cerca  = 1 - e.z / an;
        var grosor = Math.max(0.4, cerca * (e.roja ? 2.6 : 1.7));
        var alfa   = Math.min(1, 0.15 + cerca * 1.1);

        if (e.roja) {
          ctx.strokeStyle = "rgba(" + ROJO + "," + alfa.toFixed(3) + ")";
          ctx.shadowColor = "rgba(" + ROJO + ",0.9)";
          ctx.shadowBlur  = 8 * cerca;
        } else {
          ctx.strokeStyle = "rgba(255,255,255," + (alfa * 0.9).toFixed(3) + ")";
          ctx.shadowBlur  = 0;
        }
        ctx.lineWidth = grosor;
        ctx.lineCap = "round";
        ctx.beginPath();
        ctx.moveTo(px, py);
        ctx.lineTo(x, y);
        ctx.stroke();
      }
      ctx.shadowBlur = 0;
    }

    function fotograma() { if (!corriendo) return; pintar(true); lazo = window.requestAnimationFrame(fotograma); }
    function arrancar()  { if (corriendo || QUIETO) return; corriendo = true; lazo = window.requestAnimationFrame(fotograma); }
    function parar()     { corriendo = false; if (lazo) window.cancelAnimationFrame(lazo); }

    function iniciar() {
      if (!medir()) return;
      poblar();
      ctx.fillStyle = "rgb(" + FONDO + ")";
      ctx.fillRect(0, 0, an, al);
      pintar(false);
      if (!QUIETO) arrancar();
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (filas) {
        filas[0].isIntersecting ? arrancar() : parar();
      }, { threshold: 0 }).observe(lienzo);
    }
    document.addEventListener("visibilitychange", function () { document.hidden ? parar() : arrancar(); });

    var envoltura = lienzo.parentNode, pendiente = false;
    function seguir() {
      pendiente = false;
      var caja = envoltura.getBoundingClientRect();
      var tope = Math.max(0, Math.min(-caja.top, caja.height - al));
      lienzo.style.transform = "translateY(" + tope + "px)";
    }
    window.addEventListener("scroll", function () {
      if (!pendiente) { pendiente = true; window.requestAnimationFrame(seguir); }
    }, { passive: true });

    var espera = 0;
    window.addEventListener("resize", function () {
      clearTimeout(espera);
      espera = setTimeout(function () { parar(); iniciar(); }, 180);
    });

    iniciar();
    seguir();
    if (an === 0) window.setTimeout(function () { iniciar(); seguir(); }, 300);
  }

  function entradas() {
    var piezas = document.querySelectorAll(".gt-in:not(.gt-seen)");
    if (!piezas.length) return;
    if (QUIETO || !window.IntersectionObserver) {
      for (var j = 0; j < piezas.length; j++) piezas[j].classList.add("gt-seen");
      return;
    }
    var vigia = new IntersectionObserver(function (filas) {
      for (var i = 0; i < filas.length; i++) {
        if (filas[i].isIntersecting) { filas[i].target.classList.add("gt-seen"); vigia.unobserve(filas[i].target); }
      }
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    for (var k = 0; k < piezas.length; k++) vigia.observe(piezas[k]);
  }

  function imanes() {
    if (QUIETO || !window.matchMedia || !window.matchMedia("(hover:hover)").matches) return;
    var botones = document.querySelectorAll("[data-gt-iman]:not([data-gt-iman-listo])");
    for (var i = 0; i < botones.length; i++) (function (b) {
      b.setAttribute("data-gt-iman-listo", "1");
      var fuerza = parseFloat(b.dataset.gtIman) || 10;
      b.addEventListener("mousemove", function (ev) {
        var c = b.getBoundingClientRect();
        var dx = (ev.clientX - (c.left + c.width / 2)) / (c.width / 2);
        var dy = (ev.clientY - (c.top + c.height / 2)) / (c.height / 2);
        b.style.transform = "translate(" + (dx * fuerza).toFixed(2) + "px," + (dy * fuerza).toFixed(2) + "px)";
      });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    })(botones[i]);
  }

  function arrancarTodo() {
    var cielos = document.querySelectorAll("[data-gt-cielo]");
    for (var i = 0; i < cielos.length; i++) cielo(cielos[i]);
    entradas();
    imanes();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancarTodo);
  else arrancarTodo();

  document.addEventListener("shopify:section:load", arrancarTodo);
})();
